<template>
  <div class="alert_overlay" v-if="isVisible">
    <div class="alert_wrapper">
      <div class="title heading_7">{{ title }}</div>
      <div class="content_wrapper body_8 f_gray_4">{{ content }}</div>
      <div class="alert_button_wrapper" v-if="!!primaryText || !!secondaryText">
        <Button
          v-if="!!secondaryText"
          :label="secondaryText"
          :color="'gray'"
          :ghost="true"
          :onClick="handleSecondaryClick"
          :size="44"
        />
        <Button
          v-if="!!primaryText"
          :label="primaryText"
          :onClick="handlePrimaryClick"
          :size="44"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../../components/ai/AiButton.vue'

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: false
    },
    primaryText: {
      type: String,
      default: ''
    },
    secondaryText: {
      type: String,
      default: ''
    },
    onClickPrimary: {
      type: Function
    },
    onClickSecondary: {
      type: Function
    }
  },
  components: {
    Button
  },
  methods: {
    handlePrimaryClick () {
      this.onClickPrimary()
    },
    handleSecondaryClick () {
      this.onClickSecondary()
    }
  }
}
</script>

<style scope>
.alert_overlay {
  position: fixed;
  overflow: auto;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: var(--zIndex-dim);
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.alert_wrapper {
  width: 100%;
  background-color: var(--gray-scale-12);
  padding: 24px 12px;
  border-radius: 16px;
  z-index: var(--zIndex-alert);
}

.alert_wrapper > .title {
  text-align: center;
  white-space: pre-line;
  margin-bottom: 24px;
}

.alert_wrapper > .content_wrapper {
  white-space: pre-line;
  word-break: keep-all !important;
  text-align: center;
}
.alert_button_wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiAlert.vue